import * as THREE from "three"
import { useFrame } from "@react-three/fiber"
import { useRef, Suspense } from "react"
import { clampFrac, lerp, pinPosition } from "../util"
import useStore from "../AppStore"
import PointCoin from "../3d/PointCoin"

export default function ScenePointCloud(props) {
  
  const groupRef = useRef(null)
  // const groupRef = useRef(null)

  useFrame(({clock}) => {
    const top = useStore.getState().top
    groupRef.current.rotation.order = 'ZYX'
    groupRef.current.rotation.y =  Math.sin(clock.elapsedTime*0.5)*.4
    groupRef.current.rotation.z = lerp(groupRef.current.rotation.z, Math.min(11, 1 + top * 0.002), 0.1)
  })
  
  return(
    <group
      position={[0,0,0]}
      rotation={[Math.PI/2,0,0]}
    >
      <group ref={groupRef}>
      <Suspense fallback={null}>
        <PointCoin />
      </Suspense>
      </group>
    </group>
  )
}